// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3pp1j","footer":"ModalError_footer__2AFOh"};